import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

const backendURL = `${AWS_API_URL}/renovation/checkout`;

export async function submitMaintenanceOrderAPI(orderRef, maintenanceOrder, locale) {
  return postRequest(backendURL, { bankId: orderRef, rooms: maintenanceOrder, language: locale }, await authorize());
}
